import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-280" />, document.getElementById('root'));
// Defer Facebook Pixel — load after page is interactive
window.addEventListener('load', () => {
  setTimeout(() => {
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(s);
    f.fbq('init', '1545009850674181');
    f.fbq('track', 'PageView');
  }, 2000);
}, {
  once: true
});